(() => {
  const SELECTOR = '.reebwerk-transparency';
  const TITLE = 'REEBWERK Transparenzversprechen';
  const SUBTITLE = 'Was wir dir zu unseren Produkten offenlegen';

  function summaryMarkup() {
    return `
      <span class="reebwerk-transparency__summary-copy">
        <span class="reebwerk-transparency__summary-title">${TITLE}</span>
        <span class="reebwerk-transparency__summary-subtitle">${SUBTITLE}</span>
      </span>
    `;
  }

  function normalizeDetails(details) {
    if (!details || details.dataset.reebwerkTransparencyReady === 'true') return;

    details.classList.add('reebwerk-transparency');
    details.removeAttribute('style');
    details.removeAttribute('open');

    let summary = details.querySelector(':scope > summary');
    if (!summary) {
      summary = document.createElement('summary');
      details.prepend(summary);
    }

    summary.removeAttribute('style');
    summary.innerHTML = summaryMarkup();
    summary.setAttribute('aria-label', `${TITLE} – öffnen oder schließen`);

    let content = details.querySelector(':scope > .reebwerk-transparency__content');
    if (!content) {
      const wrapper = document.createElement('div');
      wrapper.className = 'reebwerk-transparency__content';

      Array.from(details.children).forEach((child) => {
        if (child !== summary) wrapper.appendChild(child);
      });

      details.appendChild(wrapper);
      content = wrapper;
    }

    content.removeAttribute('style');
    const eyebrow = content.querySelector('.reebwerk-transparency__eyebrow');
    if (eyebrow) eyebrow.remove();

    details.dataset.reebwerkTransparencyReady = 'true';
  }

  function convertLegacyAside(aside) {
    const details = document.createElement('details');
    details.className = aside.className;

    const summary = document.createElement('summary');
    summary.innerHTML = summaryMarkup();
    summary.setAttribute('aria-label', `${TITLE} – öffnen oder schließen`);

    const content = document.createElement('div');
    content.className = 'reebwerk-transparency__content';

    Array.from(aside.childNodes).forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('reebwerk-transparency__eyebrow')) return;
      content.appendChild(node);
    });

    details.append(summary, content);
    aside.replaceWith(details);
    normalizeDetails(details);
  }

  function init(root = document) {
    root.querySelectorAll(SELECTOR).forEach((block) => {
      if (block.tagName.toLowerCase() === 'details') {
        normalizeDetails(block);
      } else {
        convertLegacyAside(block);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
